import { app } from '../../bootstrap/core';
import { zkgDocumentsState } from './zkgDocuments.state';

app.config(zkgDocumentsState);
